import { render, staticRenderFns } from "./cardGroupStat.vue?vue&type=template&id=b2455aa2&scoped=true&"
import script from "./cardGroupStat.vue?vue&type=script&lang=js&"
export * from "./cardGroupStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2455aa2",
  null
  
)

export default component.exports